import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import GlobalConfirmationModal from './GlobalConfirmationModal';

const queue = [];
let listener = null;

function publish() {
  if (listener) listener(queue[0] || null);
}

function requestDialog(request) {
  return new Promise((resolve) => {
    queue.push({ ...request, resolve });
    publish();
  });
}

function settle(value) {
  const current = queue.shift();
  if (!current) return;
  current.resolve(value);
  publish();
}

export function confirmDialog(message, options = {}) {
  return requestDialog({
    kind: 'confirm',
    title: options.title || 'Confirm Action',
    message,
    confirmLabel: options.confirmLabel || 'Confirm',
    cancelLabel: options.cancelLabel || 'Cancel',
    confirmColor: options.confirmColor || 'danger',
  });
}

export function promptDialog(message, defaultValue = '', options = {}) {
  return requestDialog({
    kind: 'prompt',
    title: options.title || 'Additional Information',
    message,
    defaultValue: String(defaultValue ?? ''),
    confirmLabel: options.confirmLabel || 'Continue',
    cancelLabel: options.cancelLabel || 'Cancel',
  });
}

export default function EveryIdDialogHost() {
  const [request, setRequest] = useState(null);
  const [value, setValue] = useState('');

  useEffect(() => {
    listener = setRequest;
    publish();
    return () => {
      if (listener === setRequest) listener = null;
    };
  }, []);

  useEffect(() => {
    if (request?.kind === 'prompt') setValue(request.defaultValue);
  }, [request]);

  if (!request) return null;
  if (request.kind === 'confirm') {
    return (
      <GlobalConfirmationModal
        show
        title={request.title}
        message={request.message}
        confirmLabel={request.confirmLabel}
        cancelLabel={request.cancelLabel}
        confirmColor={request.confirmColor}
        onConfirm={() => settle(true)}
        onCancel={() => settle(false)}
      />
    );
  }

  const submit = (event) => {
    event.preventDefault();
    settle(value);
  };
  return (
    <Modal show onHide={() => settle(null)} centered>
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title>{request.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="everyid-dialog-input">
            <Form.Label>{request.message}</Form.Label>
            <Form.Control
              autoFocus
              value={value}
              onChange={(event) => setValue(event.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => settle(null)}>{request.cancelLabel}</Button>
          <Button variant="primary" type="submit">{request.confirmLabel}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
